import React, { Component } from 'react';

import OverlayLoading from '../../common/overlayLoading/OverlayLoading';
import Select from '../../common/select/Select';
import PublicationListSection from './publicationListSection/PublicationListSection';
import PageStepper from '../../common/pageStepper/PageStepper';

import { chunkArray } from '../../helpers/ArrayHelper';
import { fetchPublications } from '../../helpers/DataProvider';
import { categorizePublications, flattenCategorizedPublications } from '../PublicationsParser';

import './PublicationsList.css';


class PublicationsListSection extends Component {
  constructor() {
    super();

    this.state = {
      isLoading: true,
      orderedPublications: [],
      maxPublicationsPerPage: 10,
      pages: [],
      currentPage: 0,
      selectedOption: { value: 'no-filter', label: '#YEAR' },
      yearOptions: [],
    };

    this.topListRef = React.createRef();

    this.filterYear = this.filterYear.bind(this);
    this.goToPage = this.goToPage.bind(this);
  }

  componentDidMount() {
    fetchPublications((publications) => {
      const { maxPublicationsPerPage, selectedOption } = this.state;

      const categorizedPublications = categorizePublications(publications);
      const orderedPublications = flattenCategorizedPublications(categorizedPublications);

      const pages = chunkArray(orderedPublications, maxPublicationsPerPage);
      const years = Object.keys(categorizedPublications).sort((a, b) => b - a);

      const mappedYears = years.map(year => ({ value: year, label: `#${year}` }));
      const yearOptions = [selectedOption].concat(mappedYears);

      this.setState({
        isLoading: false,
        orderedPublications,
        pages,
        yearOptions,
      });
    });
  }

  filterYear(selectedOption) {
    const { value } = selectedOption;
    const selectedYear = value === 'no-filter' ? null : value;

    const { orderedPublications, maxPublicationsPerPage } = this.state;

    const filterByYear = (publications, year) => publications.filter(publication => (
      publication.year === year
    ));

    const publications = selectedYear
      ? filterByYear(orderedPublications, selectedYear)
      : orderedPublications;

    this.setState({
      pages: chunkArray(publications, maxPublicationsPerPage),
      currentPage: 0,
      selectedOption,
    });
  }

  scrollToTopOfList() {
    window.scrollTo(0, this.topListRef.current.offsetTop - 100);
  }

  goToPage(pageNumber) {
    this.setState({
      currentPage: pageNumber,
    }, () => {
      const steppers = document.getElementsByClassName('stepper');
      for (let i = 0; i < steppers.length; i += 1) {
        steppers[i].blur();
      }
      this.scrollToTopOfList();
    });
  }

  render() {
    const {
      isLoading, pages, currentPage, selectedOption, yearOptions,
    } = this.state;
    const publications = pages[currentPage];
    let sections;
    const sectionsDisplayingYear = [];

    if (publications && publications.length > 0) {
      let currentYear = publications[0].year;
      let currentType = publications[0].type;
      sections = [];
      let currentSection = [];
      publications.forEach((publication) => {
        if (publication.year === currentYear && publication.type === currentType) {
          currentSection.push(publication);
        } else {
          sections.push(currentSection);
          currentYear = publication.year;
          currentType = publication.type;
          currentSection = [publication];
        }
      });
      sections.push(currentSection);

      // Only the first section of the year displays it
      const displayedYears = [];
      sections.forEach((section, index) => {
        const { year } = section[0];
        if (!displayedYears.includes(year)) {
          displayedYears.push(year);
          sectionsDisplayingYear.push(index);
        }
      });
    }

    return (
      <div id="publicationsListSection" ref={this.topListRef}>
        <OverlayLoading loading={isLoading} />
        <div className="styled-select">
          <Select
            value={selectedOption}
            options={yearOptions}
            onChange={value => this.filterYear(value)}
          />
        </div>

        {
          sections && sections.map((section, index) => (
            <PublicationListSection
              publicationType={section[0].type}
              publicationYear={sectionsDisplayingYear.includes(index) ? section[0].year : ''}
              publications={section}
              key={`${section[0].year}-${section[0].type}`}
            />
          ))
        }

        <PageStepper
          currentPage={currentPage}
          totalPages={pages.length}
          goToPage={page => this.goToPage(page)}
        />
      </div>
    );
  }
}

export default PublicationsListSection;
